import React, { useContext, useEffect, useState } from "react";
import { Link, useNavigate  } from "react-router-dom";
import { CartContext } from "../contexts/CartContext.js";
// import { AuthContext } from "../contexts/AuthContext.js";

import CartProductCard from "../components/CartProductCard.js";
import OrderSummary from "../components/OrderSummary.js";
import Loader from '../components/Loader.js';

import Reassurance from '../components/Reassurance.js';

import "../styles/CartPage.css";

export default function CartPage() {
  const { cartItems, removeFromCart, clearCart } = useContext(CartContext);
  const [isCheckedRentContract, setIsCheckedRentContract] = useState(false);
  // const authCtx = useContext(AuthContext);
  const navigate = useNavigate();

  useEffect(() => {
    if (!cartItems.length) {
      navigate("/");
    }
    // eslint-disable-next-line
  }, [cartItems]);

  const centsToEuros = (cents) => {
    if (!cents) return 0;
    return cents / 100;
  };

  const calculateOneTimeTotal = () => {
    return cartItems
      .filter((item) => item.price?.type === "one_time")
      .reduce((acc, item) => {
        return acc + centsToEuros(item.price.unit_amount) * (item.quantity || 1);
      }, 0);
  };

  const calculateAmoutReduced = () => {
    return cartItems.reduce((acc, item) => {
      // Récupère le prix initial s'il existe, sinon 0
      const initPrice = item.price.metadata?.init_price
        ? parseFloat(item.price.metadata.init_price.replace(",", "."))
        : centsToEuros(item.price.unit_amount);
  
      // Convertit le prix actuel de cents en euros
      const currentPrice = centsToEuros(item.price.unit_amount);
  
      // Calcule la différence sur cet article
      return acc + (initPrice - currentPrice);
    }, 0);
  };

  const calculateTotalInitPrice = () => {
    return cartItems.reduce((acc, item) => {
      // Récupère le prix initial s'il existe, sinon 0
      const initPrice = item.price.metadata?.init_price
        ? parseFloat(item.price.metadata.init_price.replace(",", "."))
        : centsToEuros(item.price.unit_amount);
  
      // On cumule simplement tous les initPrice
      return acc + initPrice;
    }, 0);
  };
  

  const calculateRecurringMonthlyTotal = () => {
    return cartItems
      .filter((item) => item.price?.type === "recurring")
      .reduce((acc, item) => {
        return acc + centsToEuros(item.price.unit_amount) * (item.quantity || 1);
      }, 0);
  };

  const calculateTotalActivationFees = () => {
    return cartItems
      .filter((item) => item.price?.type === "recurring")
      .reduce((acc, item) => {
        const fee = parseFloat(item.price.metadata?.activation_fees || "0");
        return acc + fee * (item.quantity || 1);
      }, 0);
  };

  const handleCheckboxChange = (event) => {
    setIsCheckedRentContract(event.target.checked);
  };

  const oneTimeTotal = calculateOneTimeTotal() / 1.2;
  const recurringMonthlyTotal = calculateRecurringMonthlyTotal();
  const totalActivationFees = calculateTotalActivationFees();
  const totalReduced = calculateAmoutReduced();
  const totalInitPrice = calculateTotalInitPrice();

  const taxesOneTime = (calculateOneTimeTotal() / 120)*20;
  const oneTimeTotalTTC = oneTimeTotal + taxesOneTime;
 
  const firstSubscriptionPayment = recurringMonthlyTotal + totalActivationFees;
  const taxesRecuring = firstSubscriptionPayment / 1.2;

  return (
    <div className="cart-page" style={{ maxWidth: "800px", margin: "0 auto", padding: "2rem" }}>
      {cartItems.length === 0 ? (
        // <p className="cart-empty">Votre panier est vide.</p>
        <Loader />
      ) : (
        <div className="cart-content">

          <Reassurance /> 

          {/* {oneTimeTotal > 0 && (
            <div className="cart-summary">
              <h4>Achat direct</h4>
              <p>
                <strong>Total HT :</strong>{" "}
                {oneTimeTotal.toFixed(2)} €
              </p>
              <p>TVA (20 %) : {taxesOneTime.toFixed(2)} €</p>
              <p>
                <strong>Total TTC :</strong> {oneTimeTotalTTC.toFixed(2)} €
              </p>
            </div>
          )}

          {recurringMonthlyTotal > 0 && (
            <div className="cart-summary">
              <h4>Abonnement mensuel</h4>
              <p>
                Mensualité :{" "}
                <strong>{recurringMonthlyTotal.toFixed(2)} € / mois</strong>
              </p>
              <p><strong>Sans engagement !</strong></p>
              {totalActivationFees > 0 && (
                <p>
                  Frais d’activation :{" "}
                  <strong>{totalActivationFees.toFixed(2)} €</strong>
                </p>
              )}
            </div>
          )} */}

          <div className="cart-products">
            {cartItems.map((item, index) => (
              <CartProductCard
                key={index}
                product={item}
                onRemove={() => removeFromCart(item.id)}
              />
            ))}
          </div>

          <OrderSummary
            subtotal={(oneTimeTotalTTC + firstSubscriptionPayment).toFixed(2)}
            shippingCost={null}
            taxes={(taxesRecuring + taxesOneTime).toFixed(2)}
            totalReduced={totalReduced}
            totalInitPrice={totalInitPrice}
          />

          {
            recurringMonthlyTotal > 0 &&
            <div>
              <label>
                <input 
                  type="checkbox" 
                  checked={isCheckedRentContract}
                  onChange={handleCheckboxChange}
                />
                J'accepte les <Link to="/rent-contract">conditions de l’abonnement</Link>.
              </label>
            </div>
          }


          <div className="cart-buttons">
            <Link
              to={"/checkout/shipping"}
              className="cart-checkout-link"
            >
              <button className="cart-checkout-button" disabled={recurringMonthlyTotal > 0 ? !isCheckedRentContract : false}>
                Valider le panier
              </button>
            </Link>
          </div>

          <div className="cart-options">
            <button className="cart-clear-button" onClick={clearCart}>
              Vider le panier
            </button>
          </div>

          <Link
              to={"/"}
              style={{textDecoration: 'none', color: '#000'}}
            >
              {'<'}  Retour
            </Link>
        </div>
      )}
    </div>
  );
}
